export enum DialogButtonConfigurationEnum {
    YesNo,
    DeleteCancel,
    ConfirmCancel,
    Ok
}
